import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { doraEntityContent } from './DoraEntityContent';

// Fleet-wide DORA now lives as an admin-only tab (modules/admin/DoraSection.tsx),
// not a standalone /dora page. This plugin only contributes the per-service
// entity tab.
export const doraPlugin = createFrontendPlugin({
  pluginId: 'dora',
  extensions: [doraEntityContent],
});
